import classnames from 'classnames';
import * as React from 'react';
import { isMobile } from 'react-device-detect';

import CallIcon from '../icon-call';
import FavoriteIcon from '../icon-favorite';

const styles = require('./SecondaryCTA.scss');

export interface IProps {
    name: string;
    nameAsH1: boolean; // Wether or not to render the name as an H1 tag (stupid SEO superstition)
    phoneNumber?: string;
    isFavorite: boolean;
    handleOnFavoriteClick: (targetIsFavorite: boolean) => Promise<boolean>;
    handleOnCallClick: (phoneNumber: string) => void;
    handleOnPhoneClick: (phoneNumber: string) => void;
}

interface State {
    phoneShowing: boolean;
}

const initialState: State = {
    phoneShowing: false,
};

// Id assigned to anchor tag for "Call Venue"
const CALL_VENUE_ID = 'call-venue';

/**
 * Secondary CTA content component, has button for calling venue and
 * favoriting the venue
 */
export default class SecondaryCTA extends React.Component<IProps> {
    readonly state: State = initialState;

    constructor(props: IProps) {
        super(props);
        this.onCallClick = this.onCallClick.bind(this);
    }

    public render() {
        return (
            <div className={styles.className}>
                {this.props.nameAsH1 ? (
                    <h1 className={styles.venueName} itemType='venue-name'>
                        {this.props.name}
                    </h1>
                ) : (
                    <div className={styles.venueName} itemType='venue-name'>
                        {this.props.name}
                    </div>
                )}
                <div className={styles.headline}>
                    <div className={styles.linksWrapper}>
                        {!!this.props.phoneNumber && (
                            <span className={styles.linkCallWrapper}>
                                <a
                                    id = {CALL_VENUE_ID}
                                    className={styles.linkCall}
                                    href={`tel:${this.props.phoneNumber}`}
                                    onClick={(e) => {
                                        !!this.props.phoneNumber && this.onCallClick(e);
                                    }}
                                >
                                    <span className={styles.callIcon}>
                                        <CallIcon />
                                    </span>
                                    <span className={classnames({ [styles.hidden]: !this.state.phoneShowing })}>
                                        {this.props.phoneNumber}
                                    </span>
                                    <span className={classnames({ [styles.hidden]: this.state.phoneShowing })}>CALL VENUE</span>
                                </a>
                            </span>
                        )}
                        <div className={styles.linkFavorite}>
                            <FavoriteIcon initialIsFavorite={this.props.isFavorite} handleClick={this.props.handleOnFavoriteClick} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private async onCallClick(e: React.SyntheticEvent<HTMLAnchorElement>) {
        if (!!this.props.phoneNumber) {
            if (isMobile) {
                e.preventDefault();

                this.props.handleOnPhoneClick(this.props.phoneNumber);

                const phoneNumber = document.getElementById(CALL_VENUE_ID)?.getAttribute('href') || `tel:${this.props.phoneNumber}`;
                location.href = phoneNumber;
            } else {
                if (this.state.phoneShowing) {
                    this.props.handleOnPhoneClick(this.props.phoneNumber);
                } else {
                    e.preventDefault();

                    this.props.handleOnCallClick(this.props.phoneNumber);
                    this.setState({ phoneShowing: true });
                }
            }
        }
    }
}
